import type { DraftValidationOrgSummary as DraftValidationOrgSummaryData } from "../../api/queries/adminQueries";

type DraftValidationOrgSummaryProps = {
  summary: DraftValidationOrgSummaryData | undefined;
  isLoading?: boolean;
};

export const DraftValidationOrgSummary = ({
  summary,
  isLoading = false,
}: DraftValidationOrgSummaryProps) => {
  const total = summary?.total ?? 0;
  const traced = summary?.traced ?? 0;
  const edited = summary?.edited ?? 0;
  const withFeedback = summary?.with_feedback ?? 0;

  return (
    <div className="grid grid-cols-2 gap-3 sm:grid-cols-4">
      <div className="rounded-lg border border-slate-200 bg-white px-4 py-3 shadow-sm">
        <p className="text-xs font-medium uppercase tracking-wide text-slate-500">
          Total drafts
        </p>
        <p className="mt-1 text-2xl font-semibold text-slate-900">
          {isLoading ? "…" : total}
        </p>
      </div>
      <div className="rounded-lg border border-slate-200 bg-white px-4 py-3 shadow-sm">
        <p className="text-xs font-medium uppercase tracking-wide text-slate-500">
          Traced
        </p>
        <p className="mt-1 text-2xl font-semibold text-slate-900">
          {isLoading ? "…" : traced}
        </p>
      </div>
      <div className="rounded-lg border border-slate-200 bg-white px-4 py-3 shadow-sm">
        <p className="text-xs font-medium uppercase tracking-wide text-slate-500">
          Edited
        </p>
        <p className="mt-1 text-2xl font-semibold text-slate-900">
          {isLoading ? "…" : edited}
        </p>
      </div>
      <div className="rounded-lg border border-slate-200 bg-white px-4 py-3 shadow-sm">
        <p className="text-xs font-medium uppercase tracking-wide text-slate-500">
          With feedback
        </p>
        <p className="mt-1 text-2xl font-semibold text-slate-900">
          {isLoading ? "…" : withFeedback}
        </p>
      </div>
    </div>
  );
};
